import Sucursales from 'apps/Sucursales'
import axios from 'axios'
import {
  branches,
  landingBranches,
} from 'vars'
import get from 'lodash/get'
import { getCommonStaticProps } from 'commonPage'
import commonMessages from 'lang/es/common'
import sucursalesMessages from 'lang/es/sucursales'
import sycMessages from 'lang/es/sell-your-car'
import { safePromise } from 'utils/universal/safePromise'

export default Sucursales

export async function getStaticProps() {
  const commonStaticProps = await getCommonStaticProps()
  const messages = {
    ...commonMessages,
    ...sycMessages,
    ...sucursalesMessages,
  }

  const locationsUrl = `${process.env.NEXT_PUBLIC_API_ROOT}/api/inspection_options/77500`
  const { result: locationsResult } = await safePromise(axios(locationsUrl))
  const locations = get(locationsResult, 'data.branches', [])

  return {
    props: {
      titleMeta: 'BRANCHES_TITLE',
      descriptionMeta: 'BRANCHES_DESCRIPTION',
      headerProps: {
        activeIndex: 4,
        showBackButton: false,
        whatsappMessage: {
          id: 'VTA_WHATSAPP_MESSAGE',
          whatsappVTA: true,
        },
        variantWhatsappPhone: 'clikauto',
      },
      branches,
      messages,
      locations,
      landingBranches,
      ...commonStaticProps,
    },
  }
}
